import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Products from "../components/sections/Products";
import Store from "../components/sections/Store";
import ProcessWhy from "../components/sections/ProcessWhy";
import Secondary from "../components/sections/Secondary";
import Founder from "../components/Founder";
import Locations from "../components/sections/Locations";
import FinalCTA from "../components/sections/FinalCTA";
import Contact from "../components/sections/Contact";

export default function Home({ ready }) {
  return (
    <div data-testid="home-page">
      <Hero ready={ready} />
      <Marquee />
      <Products />
      <Store />
      <Marquee dark />
      <ProcessWhy />
      <Secondary />
      <Founder />
      <Locations />
      <FinalCTA />
      <Contact />
    </div>
  );
}
